import {
    RrsTemplate,
    RrsTemplateLabel,
} from "server/models"
import { OrderType, StateType, inferLiteral } from "client/utils"
import {
    RrsCategoryList,
    RrsCategoryChildParent,
    RrsCategoryFilters,
} from "client/store"
import { TableGroupedIds } from "client/components"
import * as types from "./types"

export const setRrsTemplateBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.RRS_TEMPLATE_BASE_ROUTE),
    baseRoute,
})


export const setRrsTemplateList = (templateList: types.RrsTemplateList) => ({
    type: inferLiteral(types.RRS_TEMPLATE_LIST),
    templateList,
})
export const setRrsTemplateIds = (templateIds: readonly number[]) => ({
    type: inferLiteral(types.RRS_TEMPLATE_IDS),
    templateIds,
})
export const setRrsTemplateEdit = (template: RrsTemplate) => ({
    type: inferLiteral(types.RRS_TEMPLATE_EDIT),
    template,
})


export const setRrsTemplateLabelList = (labelList: readonly RrsTemplateLabel[]) => ({
    type: inferLiteral(types.RRS_TEMPLATE_LABEL_LIST),
    labelList,
})
export const setRrsTemplateLabelCategoryList = (labelId: number, nestedCategories: number[]) => ({
    type: inferLiteral(types.RRS_TEMPLATE_LABEL_CATEGORY_LIST),
    labelId,
    nestedCategories,
})
export const setRrsTemplateLevelList = (labelId: number, levelList: types.RrsTemplateLevelByCategoryList) => ({
    type: inferLiteral(types.RRS_TEMPLATE_LEVEL_LIST),
    labelId,
    levelList,
})
export const setRrsTemplateLevelListByCategory = (
    labelId: number,
    categoryId: number,
    levelIds: number[],
    levelList: types.RrsTemplateLevelList,
) => ({
    type: inferLiteral(types.RRS_TEMPLATE_LEVEL_LIST_BY_CATEGORY),
    labelId,
    categoryId,
    levelIds,
    levelList,
})
export const setRrsTemplateRiskRankList = (riskRankList: types.RrsTemplateRiskRankList) => ({
    type: inferLiteral(types.RRS_TEMPLATE_RISK_RANK_LIST),
    riskRankList,
})


export const setRrsTemplateCategoriesCategoryList = (categoryList: RrsCategoryList) => ({
    type: inferLiteral(types.RRS_TEMPLATE_CATEGORIES_CATEGORY_LIST),
    categoryList,
})
export const setRrsTemplateCategoriesCategoryIds = (categoryIds: TableGroupedIds[]) => ({
    type: inferLiteral(types.RRS_TEMPLATE_CATEGORIES_CATEGORY_IDS),
    categoryIds,
})
export const setRrsTemplateCategoriesCategoryChildParent = (childParent: RrsCategoryChildParent) => ({
    type: inferLiteral(types.RRS_TEMPLATE_CATEGORIES_CATEGORY_CHILD_PARENT),
    childParent,
})
export const setRrsTemplateCategoriesFilters = (filters: RrsCategoryFilters) => ({
    type: inferLiteral(types.RRS_TEMPLATE_CATEGORIES_FILTERS),
    filters,
})
export const setRrsTemplateCategoriesSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.RRS_TEMPLATE_CATEGORIES_SELECTED),
    selected,
})


export const setRrsTemplateEditLoadState = (loadState: StateType) => ({
    type: inferLiteral(types.RRS_TEMPLATE_EDIT_LOAD_STATE),
    loadState,
})


export const setRrsTemplateSort = (sortColumn: keyof RrsTemplate, sortOrder: OrderType) => ({
    type: inferLiteral(types.RRS_TEMPLATE_SORT),
    sortColumn,
    sortOrder,
})
export const setRrsTemplateFilters = (filters: types.RrsTemplateFilters) => ({
    type: inferLiteral(types.RRS_TEMPLATE_FILTERS),
    filters,
})


export const setRrsTemplateReloadList = (value: boolean) => ({
    type: inferLiteral(types.RRS_TEMPLATE_RELOAD_LIST),
    value,
})
export const setRrsTemplateReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.RRS_TEMPLATE_RELOAD_EDIT),
    value,
})
